import he from "he";

export const decodeHtml = <T extends string | undefined>(html: T): T =>
	(html ? he.decode(html) : html) as T;
